<template lang="pug">
div
  el-card(shadow="hover").card-container
    p.padding-titulo Pesquisa de Modelos
    app-filtro(
      @pesquisar="pesquisar"
      @limparCampos="limpar"
      :hasButtonLimpar="true"
      :hasButtonsPesquisaAvancada="false"
      placeholderSimples="Informe a descrição"
    )
  app-listagem.listagemModelo(
    :has-refresh-button="true",
    :hasActionButton="true",
    @click="abrirModalAdicionar"
    @updateListagem="updateListagem",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="filtroConfigs.totalElements",
    @changePage="changePage",
    :pagina="filtroConfigs.number || 0"
    tituloCard="Listagem de Modelos"
    nameActionButton="Adicionar modelo"
    dadosNaoEncontrado="Não existe modelos disponíveis."
    headerLabel=""
    @executar="abrirModalGenerico"
  )
  app-modal-adicionar-modelo(
    v-if="showModalAdicionar",
    @updateAoAdicionar="updateListagem"
    @closeModal="closeModal",
  )
  app-modal(
    v-if="showModalGenerico",
    @closeModal="closeModal"
    :titulo="tituloModal"
  )
    //- MODAL VISUALIZAR
    template(slot="body", v-if="tipoAcao === 'VISUALIZAR'")
      div(v-html="modelo.textoModelo").container

    //- MODAL EXCLUIR
    template(slot="body", v-if="tipoAcao === 'EXCLUIR'")
      div.container
        p {{ `Tem certeza que deseja excluir o "${modelo.descricaoTexto}"? Após exclusão, não será possível utilizar este modelo padrão.` }}
    template(slot="footer",v-if="tipoAcao === 'EXCLUIR'")
      .flex-buttons
        el-button(@click="closeModal") Cancelar &nbsp
          .fa.fa-times
        el-button(type="primary", @click="excluirModelo") Confirmar &nbsp
          .fa.fa-check

    //- MODAL EDITAR
    template(slot="body", v-if="tipoAcao === 'EDITAR'")
      div.group
        p.required Despacho:
        app-editor-texto(
          :value="modelo.textoModelo",
          @onTextChange="onTextChange",
        )
    template(slot="footer",v-if="tipoAcao === 'EDITAR'")
      .flex-buttons
        el-button(@click="closeModal") Cancelar &nbsp
          .fa.fa-times
        salvar-modelo(v-model="updateModelo" @update:modelValue="updateModelo($event)")

</template>

<script>
import FileSaver from 'file-saver'
import axios from '@/utils/api'
import AppListagem from '@/components/AppListagem'
import AppFiltro from '@/components/AppFiltro'
import AppAnexo from '@/components/AppAnexo'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModal from '@/components/AppModal'
import AppModalAdicionarModelo from '@/screens/analise/components/AppModalAdicionarModelo'
import AppEditorTexto from '@/components/AppEditorTexto'
import SalvarModelo from './components/SalvarModelo'
import { mapActions } from 'vuex'
export default {
  components: {
    AppListagem,
    AppFiltro,
    AppModal,
    AppModalAdicionarModelo,
    AppEditorTexto,
    AppAnexo,
    SalvarModelo
  },
  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      items: [],
      totalElements: 12,
      showModalAdicionar: false,
      showModalGenerico: false,
      modelo: {},
      titulos: {
        VISUALIZAR: 'Visualizar',
        EDITAR: 'Editar',
        EXCLUIR: 'Excluir'
      },
      filtroConfigs: {},
      showUpload: false,
      errorsAnexo: [],
      colunas: [
        { id: 0, titulo: 'Modelo', propriedade: 'tipoModelo', ordem: 1, acoes: [] },
        { id: 1, titulo: 'Descrição', propriedade: 'descricaoTexto', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Responsável', propriedade: 'nomeResponsavel', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data de atualização', propriedade: 'dataAtualizacao', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Ações', propriedade: 'tipo', ordem: 5,  //eslint-disable-line
          acoes: [
            { id: 0, nome: 'Visualizar', codigo: 'VISUALIZAR', icone: 'fa-eye', ordem: 1 },
            { id: 1, nome: 'Editar', codigo: 'EDITAR', icone: 'fa-edit', ordem: 2 },
            { id: 2, nome: 'Excluir', codigo: 'EXCLUIR', icone: 'fa-trash', ordem: 3 }
          ]
        }
      ]
    }
  },

  async created () {
    const data = await this.findByFiltro({ campoSimples: this.campoSimples })
    this.setItemsFiltroConfigs(data)
  },

  computed: {
    tituloModal () {
      let titulo = this.titulos[this.tipoAcao]
      return `${titulo} - ${this.modelo.descricaoTexto}`
    }
  },

  methods: {
    ...mapActions({
      findByFiltro: 'modeloDespacho/findByFiltro',
      salvarModeloDespacho: 'modeloDespacho/salvarModeloDespacho',
      excluirModeloDespacho: 'modeloDespacho/excluirModeloDespacho'
    }),

    async updateListagem () {
      const data = await this.findByFiltro({ campoSimples: this.campoSimples })
      this.setItemsFiltroConfigs(data)
      this.filtroConfigs.number = 0
      this.items = data.content
    },

    async pesquisar (filtro) {
      const data = await this.findByFiltro({ campoSimples: filtro.campoSimples, pagina: 0 })
      this.setItemsFiltroConfigs(data)
    },

    async changePage (newPage) {
      const data = await this.findByFiltro({ campoSimples: '', pagina: newPage - 1 })
      this.setItemsFiltroConfigs(data)
    },

    setItemsFiltroConfigs (data) {
      this.filtroConfigs = data
      this.items = data.content
    },

    abrirModalAdicionar () {
      this.showModalAdicionar = true
    },

    closeModal () {
      this.showModalGenerico = false
      this.showModalAdicionar = false
      this.showUpload = false
      this.limpar()
    },

    abrirModalGenerico (modelo) {
      if (modelo.acao === 'BAIXAR') {
        this.getDownload(modelo.item.documentoReurb)
      } else {
        this.showModalGenerico = true
        this.tipoAcao = modelo.acao
        this.modelo = modelo.item
      }
    },

    onTextChange (value) {
      this.modelo.textoModelo = value
    },

    async updateModelo ($event) {
      if ($event) {
        delete this.modelo.tipoModelo
        this.salvarModeloDespacho(this.modelo).then(() => {
          this.closeModal()
          this.updateListagem()
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Modelo editado com sucesso!')
        })
      }
    },

    async excluirModelo () {
      this.excluirModeloDespacho({ id: this.modelo.id }).then(() => {
        this.closeModal()
        this.updateListagem()
      })
    },

    limpar () {
      this.updateListagem()
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    uploadFile (file) {
      this.modelo.documentoReurb = {
        key: file.response,
        nome: file.name,
        tipo: {
          id: 193,
          codigo: 'DOCUMENTO_GABINETE'
        }
      }
      this.showUpload = false
    },
    async removeFile (documento) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          this.modelo.documentoReurb = null
          this.showUpload = true
        },
        () => { })
    },
    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    }
  }
}
</script>

<style scoped lang="scss">
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.container {
  padding: 20px;
}

.group {
  padding: 30px;
}
.group:not(:first-child) {
  margin: 5px 0;
}

.group p.required:after {
    color: red;
    content: " *";
}

.padding-titulo {
  padding-left: 10px;
}

.flex-buttons {
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
}

@media (max-width: 780px) {
  .card-container {
    margin: 0;
  }

  .listagemModelo {
    margin: 15px 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/ModelosListagem.vue